import { anodum } from '@yola/ws-sdk';

const isMediaContainer = (element) => !!element && anodum.isTag(element, 'ws-media-container');
const isIframe = (element) => !!element && anodum.isTag(element, 'ws-iframe');

const isMediaContainerWithIframe = (element) =>
  isMediaContainer(element) && isIframe(element.firstElementChild);

export default isMediaContainerWithIframe;
